import React, { forwardRef } from 'react';
import type { IconProps } from '@components/atoms/icon/types';
import cn from 'classnames';

import { IconContainer } from './styles';

export const Icon = forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    const { icon, color, style, variant, shape, ...rest } = props;

    return (
        <IconContainer
            ref={ref}
            {...rest}
            style={{ color, ...style }}
            className={cn(
                variant,
                shape,
                rest?.$clickable ? 'clickable' : undefined,
                rest.className,
            )}
        >
            {icon}
        </IconContainer>
    );
});
